import { RowDataSourceTable } from 'types/graphql-global-types';

export type DataFilter = {
    id: string;
    fieldKey: string;
    fieldName: string;
    label: string;
    recordId: string;
    configId: string;
    createdByFullName?: string;
    created?: Date;
    updatedByFullName?: string;
    updated?: Date;
    dataSource?: RowDataSourceTable | undefined | null;
    isDefault: boolean | undefined | null;
    displayIndex: number;
    isFieldActiveOrExists: boolean;
};
export type FilterForm = {
    field: FieldType;
    label: string;
    configId: string;
    id: string;
};

export enum ChipValues {
    SiteFilters = 1,
    SubjectFilters = 2,
    DataFilters = 3,
}
export interface DataFilterResultType {
    id: string | null;
    recordId: string | null;
    configId: string | null;
    fieldKey: string | null;
    fieldName?: string | null;
    label: string | null;
    dataSource: RowDataSourceTable | null;
    displayIndex: number | null;
    isDefault: boolean | null;
    createdBy?: { firstName: string | null; lastName: string | null } | null;
    created?: Date;
    updatedBy?: { firstName: string | null; lastName: string | null } | null;
    updated?: Date;
}
export interface ExtraDataFields {
    extraDataFields: ExtraDataField[];
}
export interface ExtraDataField {
    id: string;
    friendlyName: string;
    table: RowDataSourceTable;
    sourceFieldName: string;
    active: boolean;
}

export interface FieldType {
    name: string;
    key: string;
    dataType: RowDataSourceTable;
    active: boolean;
    status: string;
}
